import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserIcon, BuildingStorefrontIcon } from '@heroicons/react/24/outline';

const UserTypeSelection = () => {
  const navigate = useNavigate();
  const userTypes = [
    {
      id: 'customer',
      title: 'I am a Customer',
      description: 'Book appointments, discover businesses, manage your bookings',
      icon: UserIcon,
      color: 'bg-blue-500',
      bgGradient: 'from-blue-400 to-blue-600'
    },
    {
      id: 'business_owner',
      title: 'I am a Business Owner',
      description: 'List your business, manage staff, accept bookings, grow your business',
      icon: BuildingStorefrontIcon,
      color: 'bg-green-500',
      bgGradient: 'from-green-400 to-green-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-5xl w-full">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Welcome to BookFlow</h1>
          <p className="text-xl text-gray-600">Choose how you want to use our platform</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {userTypes.map((type) => (
            <div
              key={type.id}
              onClick={() => navigate(`/register/${type.id}`)}
              className="group cursor-pointer transform transition-all duration-300 hover:scale-105"
            >
              <div className={`bg-gradient-to-r ${type.bgGradient} rounded-2xl p-8 shadow-lg text-white h-full`}>
                <div className="flex justify-center mb-6">
                  <div className="p-4 bg-white bg-opacity-20 rounded-full">
                    <type.icon className="h-16 w-16" />
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-center mb-3">{type.title}</h2>
                <p className="text-center text-white text-opacity-90 mb-6">
                  {type.description}
                </p>
                <div className="text-center">
                  <button className="px-6 py-2 bg-white text-gray-900 rounded-lg font-medium hover:shadow-lg transition-shadow">
                    Select Option
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-500">
            Already have an account?{' '}
            <button 
              onClick={() => navigate('/login')}
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Sign In
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserTypeSelection;